import Lockr from 'lockr';
import {
  apiBackDataCheckRemind,
  apiDateCollectCheckRemind,
  apiDetectedCheckRemind,
  apiGetAllCanteen,
  apiGetAllClassList,
  apiGetCanteenList,
  apiGetCustomMachine,
  apiGetMachineList,
  apiQueryAllCachedDishes,
  apiQueryCanteenClassList,
  apiGetAllCategoryList
} from '@/api';
import {Loading, Message} from 'element-ui';
import util from '@/lib/util';

export default {
  handleLogin ({ state, commit }, payload) {
    commit('setUserinfo', payload.userinfo);
  },
  clearUserinfo ({ commit }) {
    commit('clearUserInfo', Lockr.set('userinfo', null));
  },
  setListQuery ({ commit, dispatch }, listQuery) {
    commit('setListQuery', listQuery);
    dispatch('setModelList');
  },
  // getModelList ({commit}, {canteenId}) {
  //   let apiKey = this.getters.userinfo().api_key;
  //   return apiGetModelList({canteenId, apiKey});
  // },
  setModelList ({ commit, dispatch, state, getters }, canteen_id = null) {
    (async () => {
      let canteenId = canteen_id || getters.listQuery.canteen.canteen_id;
      let apiKey = getters.userinfo().api_key;
      let res = await apiQueryCanteenClassList({ canteenId, apiKey });
      //
      // dispatch('getModelList', res.dish_info_list);;
      commit('setModelList', res.dish_info_list);
    })();
  },
  setMarkImageList ({ commit }, imageList) {
    commit('setMarkImageList', imageList);
  },
  setCanteenList ({ commit, state, getters, dispatch }, payload) {
    (async () => {
      let listQuery = getters.listQuery; ;
      let apiKey = getters.userinfo().api_key;
      let eateryId = listQuery.eatery.eatery_id;
      let { canteen_list } = await apiGetCanteenList({ apiKey, eateryId });
      commit('setCanteenList', canteen_list);
      let canteen = null;
      if (payload && payload.isSearch === true) {
        canteen = listQuery.canteen;
      } else {
        canteen = canteen_list[0];
      };
      let machineList = await apiGetMachineList({
        apiKey,
        canteen_id: canteen.canteen_id
      });
      commit('setMachineList', machineList);
      dispatch('setListQuery', {
        ...listQuery,
        canteen: canteen,
        machine: machineList[0]
      });
    })();
  },
  setMachineList ({ commit, state, dispatch, getters }) {
    (async () => {
      let apiKey = getters.userinfo().api_key;
      let listQuery = getters.listQuery;
      let canteen_id = listQuery.canteen.canteen_id;
      let res = await apiGetMachineList({ apiKey, canteen_id }); ;
      commit('setMachineList', res);
      dispatch('setListQuery', { ...listQuery, canteen: res[0] });
    })();
  },
  setAllClassList ({ commit, state, getters }) {
    (async () => {
      let apiKey = getters.userinfo().api_key;
      let res = await apiGetAllClassList(apiKey);
      commit('setAllClassList', res.dish_info_list);
    })();
  },
  setUncheckedDishList ({ commit }) {
    (async () => {
      try {
        let res = await apiQueryAllCachedDishes();
        res = res.filter(a => {
          return !!a.eatery_name;
        });
        commit('setUncheckedDishList', res);
      } catch (e) {
        ;
      }
    })();
  },
  setBatchList ({ commit }, batchList) {
    commit('setBatchList', batchList);
  },
  async setAllCanteenList ({commit, getters}) {
    let apiKey = getters.userinfo().api_key;
    let allCanteenList = [];
    try {
      allCanteenList = await apiGetAllCanteen(apiKey);
    } catch (e) {
      Message.error('查询全部餐厅列表失败');
    }
    commit('setAllCanteenList', allCanteenList);
    return Promise.resolve(true);
  },
  async getDetectedUnCheckRemindList ({commit, getters}, payload) {
    let loadingShow = payload ? payload.loadingShow : false;
    let refresh = payload ? payload.refresh : true;
    let loading = null;
    if (loadingShow === true) {
      loading = Loading.service({
        fullscreen: true
      });
    }
    let apiKey = getters.userinfo().api_key;
    let listQuery = getters.listQuery;
    let date_range = {
      start_ts: util.dateToUnixtimestamp(listQuery.dateRange[0], 0),
      end_ts: util.dateToUnixtimestamp(listQuery.dateRange[1], 1)
    };
    try {
      let {canteen_info_list} = await apiDetectedCheckRemind(apiKey, date_range, refresh);
      commit('getDetectedUnCheckRemindList', canteen_info_list); ;
      loading && loading.close();
    } catch (e) {
      loading && loading.close();
    }
  },
  async getBackDataUnCheckRemindList ({commit, getters}, payload) {
    let loadingShow = payload ? payload.loadingShow : false;
    let refresh = payload ? payload.refresh : true;
    let loading = null;
    if (loadingShow === true) {
      loading = Loading.service({
        fullscreen: true
      });
    }
    let listQuery = getters.listQuery;
    let date_range = {
      start_ts: util.dateToUnixtimestamp(listQuery.dateRange[0], 0),
      end_ts: util.dateToUnixtimestamp(listQuery.dateRange[1], 1)
    };
    let apiKey = getters.userinfo().api_key;
    try {
      let {canteen_info_list} = await apiBackDataCheckRemind(apiKey, date_range, refresh);
      commit('getBackDataUnCheckRemindList', canteen_info_list);
      loading && loading.close();
    } catch (e) {
      ;
      loading && loading.close();
    }
  },
  async getDataCollectCheckRemind ({commit, getters}, payload) {
    let loadingShow = payload ? payload.loadingShow : false;
    let refresh = payload ? payload.refresh : true;
    let loading = null;
    if (loadingShow === true) {
      loading = Loading.service({
        fullscreen: true
      });
    }
    let listQuery = getters.listQuery;
    let date_range = {
      start_ts: util.dateToUnixtimestamp(listQuery.dateRange[0], 0),
      end_ts: util.dateToUnixtimestamp(listQuery.dateRange[1], 1)
    };
    let apiKey = getters.userinfo().api_key;
    try {
      let {canteen_info_list} = await apiDateCollectCheckRemind(apiKey, date_range, refresh);
      commit('getDataCollectCheckRemind', canteen_info_list);
      loading && loading.close();
    } catch (e) {
      ;
      loading && loading.close();
    }
  },
  setCheckRegionData ({commit}, {data, label_task_id}) {
    commit('setCheckRegionData', []);
    commit('setCheckRegionData', data);
    commit('setLabelTaskId', label_task_id);
  },
  setPremarkData ({commit}, {data, label_task_id}) {
    commit('setPremarkData', []);
    commit('setPremarkData', data);
    commit('setLabelTaskId', label_task_id);
  },
  async setCustomMachineList ({commit}) {
    try {
      const res = await apiGetCustomMachine();
      console.log(res);
      const {machine_info_list} = res;
      commit('setCustomMachineList', machine_info_list);
    } catch (e) {
      console.log(e);
      return Promise.reject(new Error(e));
    }
  },
  toggleSideBar ({commit}) {
    commit('TOGGLE_SIDEBAR');
  },
};
